import { render, staticRenderFns } from "./ApprovedClaimsList.vue?vue&type=template&id=a9efaf8c&"
import script from "./ApprovedClaimsList.vue?vue&type=script&lang=js&"
export * from "./ApprovedClaimsList.vue?vue&type=script&lang=js&"
import style0 from "./ApprovedClaimsList.vue?vue&type=style&index=0&lang=css&"
import style1 from "./ApprovedClaimsList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports